import home from './src/home.vue'
import TicketDayTrend from './src/TicketTrend/TicketDayTrend.vue' //日售票走势
import TicketMonthTrend from './src/TicketTrend/TicketMonthTrend.vue' //月售票走势
import TicketYearTrend from './src/TicketTrend/TicketYearTrend.vue' //年售票走势


let views = {
    home,
    TicketDayTrend,
    TicketMonthTrend,
    TicketYearTrend
};

export default views;